export const CHECK_PENDING_REQUEST_INTERVAL = 500;

export const CHECK_PENDING_REQUEST_ATTEMPTS = 4;
